import { useEffect } from "react";

interface CustomDialogProps {
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
    className?: string;
    overlayClassName?: string;
}

const CustomDialog: React.FC<CustomDialogProps> = ({
    open,
    onClose,
    children,
    className = "",
    overlayClassName = "",
}) => {
    useEffect(() => {
        if (open) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [open]);

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 overflow-y-auto">
            <div
                className={`fixed inset-0 bg-black bg-opacity-50 ${overlayClassName}`}
                onClick={onClose}
            ></div>
            <div
                className={`relative z-10 bg-white rounded-lg shadow-lg p-6 ${className}`}
                onClick={(e) => e.stopPropagation()}
            >
                {children}
            </div>
        </div>
    );
};

export default CustomDialog;
